// 全局变量
var _constant = {
    testApi: 'http://192.168.10.204:8060',
    platformKey: 'project_platform',
    loginKey: 'staff_center_login_key',
  powerCode: 'power_code',
  //适用卡类别
  standardList: [

    {id: 1, name: "标准卡",platform_filter:['juyoufuli']},
    {id: 2, name: "慰问扫码",platform_filter:['juyoufuli']},
    {id: 3, name: "福利兑换",platform_filter:['juyoufuli']}
    ],
     // 卡材质
     materials: [
        {
            id: 1,
            name: '卡材质'
        },
        {
            id: 2,
            name: '劵材质'
        }
    ],
    // 是否标准
    standards: [
        {
            id: 1,
            name: '标准'
        },
        {
            id: 2,
            name: '非标准'
        }
    ],
    // 状态
    states: [
        {
            id: 1,
            name: '开启'
        },
        {
            id: 2,
            name: '冻结'
        }
    ],
    // 状态
    historyStates: [
        {
            id: 0,
            name: '未设置'
        },
        {
            id: 1,
            name: '禁用'
        },
        {
            id: 2,
            name: '启用'
        }
    ],
    // 是否制作卡套
    isMakeCovers: [
        {
            id: 1,
            name: '是'
        },
        {
            id: 2,
            name: '否'
        }
    ],
    // 入库状态
    enterStates: [
        {
            id: 1,
            name: '待入库'
        },
        {
            id: 2,
            name: '已入库'
        }
    ],
    // 作废类型
    invalidTypes: [
        {
            id: 2,
            name: '可再售'
        },
        {
            id: 3,
            name: '不可再售'
        }
    ],
    // 储值类型
    storedTypes: [
        {
            id: 1,
            name: '点卡'
        },
        {
            id: 2,
            name: '电影次卡'
        }
    ],
    // 是否特殊
    isSpecials: [
        {
            id: 2,
            name: '否'
        },
        {
            id: 1,
            name: '是'
        }
    ],
    // 订单类型
    orderTypes: [
        {
            id: 1,
            name: '储值订单'
        },
        {
            id: 2,
            name: '充值订单'
        }
    ],
    // 红冲订单类型
    redrushTypes: [
        {
            id: 1,
            name: '全部红冲'
        },
        {
            id: 2,
            name: '部分红冲'
        }
    ],
    //流程再造步骤图
    routeStepMap:{
        royaltyPlan:['编辑折算业绩与提成方案','提交成功'], //折算业绩与提成方案
        pointsPlan:['编辑折算业绩与提成方案','提交成功'] //积分方案
    }
}

export default _constant
